module.exports = __webpack_public_path__ + "static/media/10.257cb3c7.jpeg";